/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const PASSWORD_UNIQUE_MESSAGE = 'Please make sure you use a unique password, and at least different from the password you use for your LMS.';
// Indicates an object in the store that has been requested but not returned by
// the server, e.g. if it does not exist or the user has no permission to see
// the object.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const NONEXISTENT = Symbol('NONEXISTENT');
// Indicates that a value has not yet been set (e.g. in a model cache).
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const UNSET_SENTINEL = Symbol('UNSET_SENTINEL');
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const RUBRIC_BADGE_AT = '<div class="ml-1 badge badge-primary" title="This is an AutoTest category">AT</div>';
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const COLOR_PAIRS = Object.freeze([
    { background: 'rgb( 44,  62,  80)', color: 'light' },
    { background: 'rgb(112, 163, 162)', color: 'dark' },
    { background: 'rgb(203,  84,  82)', color: 'light' },
    { background: 'rgb(234, 182, 108)', color: 'dark' },
    { background: 'rgb(214, 206,  91)', color: 'dark' },
    { background: 'rgb(167, 174, 145)', color: 'dark' },
    { background: 'rgb(223, 211, 170)', color: 'dark' },
    { background: 'rgb(149, 111,  72)', color: 'light' },
    { background: 'rgb(101, 104, 108)', color: 'light' },
    { background: 'rgb( 89, 141, 134)', color: 'light' },
    { background: 'rgb(217, 126, 113)', color: 'dark' },
    { background: 'rgb(223, 184, 121)', color: 'dark' },
    { background: 'rgb( 79,  95,  86)', color: 'light' },
    { background: 'rgb(234, 219, 147)', color: 'dark' },
    { background: 'rgb(204,  58,  40)', color: 'light' },
    { background: 'rgb(215, 206, 166)', color: 'dark' },
    { background: 'rgb( 93, 141, 125)', color: 'light' },
    { background: 'rgb(230, 220, 205)', color: 'dark' },
    { background: 'rgb(180, 174, 164)', color: 'dark' },
    { background: 'rgb(210, 207, 159)', color: 'dark' },
    { background: 'rgb(231, 238, 233)', color: 'dark' },
].map(x => Object.freeze(x)));
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const INITIAL_COURSES_AMOUNT = 100;
// The max amount of extra courses that should be loaded per query when we reach
// the end of the infinite scroll list, or when looking for specific course.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const MAX_COURSES_PER_LOAD = 2500;
// Line number for comments used when the file that is commented on has no
// concept of individual lines, e.g. images, pdfs, empty files or files that
// cannot be rendered.
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const DEFAULT_LINE_NUMBER = 0;
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const BREAKPOINTS = Object.freeze({
    smallWidth: 628,
    mediumWidth: 768,
    largeWidth: 992,
    xlargeWidth: 1200,
});
